// extracted by mini-css-extract-plugin
module.exports = {"tag":"jgp-rUU4q"};